if (!customElements.get('waypoint-stop')) {
  customElements.define('waypoint-stop',
    class WaypointStop extends HTMLElement {

      // Populated by _resolveElements() on connect
      elements = {
        label: null, removeButton: null,
        addressInput: null, addressLabel: null,
        typeSelect: null, typeLabel: null,
      };

      events = {
        handleRemoveClick: () => {
          this.dispatchEvent(new CustomEvent('waypoint:remove', { bubbles: true }));
        },
      };

      // Fixed stops (pick-up / drop-off) are pre-rendered by Liquid.
      // Dynamic stops are inserted empty and need the template cloned in.
      get fixed() { return this.hasAttribute('fixed'); }

      connectedCallback() {
        this.fixed ? this._resolveElements() : this._build();
        if (!this.fixed) this.bindEvents();
      }

      disconnectedCallback() {
        if (!this.fixed) {
          this.elements.removeButton.removeEventListener('click', this.events.handleRemoveClick);
        }
      }

      bindEvents() {
        this.elements.removeButton.addEventListener('click', this.events.handleRemoveClick);
      }

      get index() { return parseInt(this.dataset.index); }

      set index(n) {
        this.dataset.index = n;
        this.elements.label.textContent = `Stop ${n}`;
        this.elements.removeButton.setAttribute('aria-label', `Remove stop ${n}`);
        this.elements.addressInput.id = `ContactForm-stop-${n}-address`;
        this.elements.addressInput.name = `contact[Stop ${n} - Address]`;
        this.elements.addressLabel.setAttribute('for', `ContactForm-stop-${n}-address`);
        this.elements.typeSelect.id = `ContactForm-stop-${n}-type`;
        this.elements.typeSelect.name = `contact[Stop ${n} - Property type]`;
        this.elements.typeLabel.setAttribute('for', `ContactForm-stop-${n}-type`);
      }

      _resolveElements() {
        this.elements.label        = this.querySelector('.waypoint-label');
        this.elements.removeButton = this.querySelector('.remove-waypoint-button');
        this.elements.addressInput = this.querySelector('.waypoint-address-input');
        this.elements.addressLabel = this.querySelector('.waypoint-address-label');
        this.elements.typeSelect   = this.querySelector('.waypoint-type-select');
        this.elements.typeLabel    = this.querySelector('.waypoint-type-label');
      }

      _build() {
        const template = document.getElementById('waypoint-stop-template');
        this.appendChild(template.content.cloneNode(true));
        this._resolveElements();
        this.index = this.index; // trigger setter to stamp ids/names
      }

    }
  );
}
